// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1vFeJ","select":"Header_select__2Y4ks","clinic":"Header_clinic__1W7Fi"};